import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import { getOrderAmount } from '@/helpers'
import routes from '@/Router/routes.constants'
import services from '@/services/services'

const useSendRefundMethod = (orderId, returnId, refundMethod) => {
  const { data, fetchData, loading, error } = useFetch(services.setRefundMethod, {
    doInitialRequest: true,
    params: { orderId, returnId, refundMethod },
  })
  const { setContext } = useContext(AppContext)
  const navigate = useNavigate()
  const { setToastInfo } = useContext(ToastContext)

  useEffect(() => {
    if (error) {
      navigate(routes.deliveryMethodsPage)
      setToastInfo({ show: true, message: error?.errorMessage, type: 'error' })
    }
  }, [error, navigate, setToastInfo])

  useEffect(() => {
    if (data) {
      setContext(context => ({
        ...context,
        orderInfo: {
          ...context.orderInfo,
          fee_messages: data?.fee_messages,
          is_instant_exchange_allowed: data?.is_instant_exchange_allowed,
        },
        orderAmount: getOrderAmount(data),
      }))
    }
  }, [data, setContext])

  const sendRefundMethod = async ({ orderId, returnId, refundMethod }) => {
    try {
      if (refundMethod) {
        const returnInfo = await fetchData({ orderId, returnId, refundMethod })
        setContext(context => ({
          ...context,
          orderAmount: getOrderAmount(returnInfo),
        }))
      }
    } catch (error) {
      setToastInfo({ show: true, message: error?.errorMessage, type: 'error' })
      navigate(routes.deliveryMethodsPage)
    }
  }

  return { data, sendRefundMethod, loading }
}

export default useSendRefundMethod
